<template>
    <div>
        <v-dialog v-model="dialog" max-width="600px" persistent>

            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2 primary" v-on="on">
                    <v-icon left dark>fa-plus</v-icon>
                    {{ $t('page.practice.add_new_practice') }}
                </v-btn>
                <v-btn dense elevation="1" class="text-center deleteSeries" @click="openDeleteConfirmationDialog()">
                    <v-icon left dark>fas fa-trash</v-icon>
                    {{ $t('page.practice.delete_practice') }}
                </v-btn>
            </template>
            <v-form ref="form" class="form">
                <v-card :loading="loading">
                    <v-card-title>
                        <span class="headline">{{ $t('page.practice.create_dialog.title') }}</span>
                    </v-card-title>
                    <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="practice.english"
                                    :rules="nameRules"
                                    @focus="focusValidate"
                                    :hint="$t('page.practice.create_dialog.label_en') + ' (' + $t('dashboard.menu.eventDetails.mandatory-optional') + ')'"
                                    :label="$t('page.practice.create_dialog.label_en')"
                                    hide-details="auto" outlined dense persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="practice.french"
                                    :rules="nameRules"
                                    @focus="focusValidate"
                                    :hint="$t('page.practice.create_dialog.label_fr') + ' (' + $t('dashboard.menu.eventDetails.mandatory-optional') + ')'"
                                    :label="$t('page.practice.create_dialog.label_fr')"
                                    hide-details="auto" outlined dense persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="practice.spanish"
                                    :rules="nameRules"
                                    @focus="focusValidate"
                                    :hint="$t('page.practice.create_dialog.label_es') + ' (' + $t('dashboard.menu.eventDetails.mandatory-optional') + ')'"
                                    :label="$t('page.practice.create_dialog.label_es')"
                                    hide-details="auto" outlined dense persistent-hint></v-text-field>
                            </v-col>
                        </v-row>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="darken-1" dark small @click="close()">{{ $t('common.form.cancel') }}</v-btn>
                        <v-btn color="darken-1" dark small @click="validate()">{{ $t('common.form.save') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <SGSNotificationConfirm 
            v-if="confirmationDialog"
            :notificationMessage="$t('common.confirm-delete')"
            @cancel="confirmationDialog = false;"
            @agree="deletePrice"
            type='warning'
        />
    </div>
</template>

<script>
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
    components: { SGSNotificationConfirm },
    data()
    {
        return {
            dialog: false,
            loading: false,
            practice: {
                english: '',
                french: '',
                spanish: '',
            },
            confirmationDialog: false,
        }
    },
    computed: {
        nameRules()
        {
            let isValid = false;

            if(this.practice.english.trim().length > 0) isValid = true;
            if(this.practice.french.trim().length > 0) isValid = true;
            if(this.practice.spanish.trim().length > 0) isValid = true;

            if(isValid) {
                this.$refs.form.resetValidation();
            }

            return [() => !!isValid || `${this.$t('page.practice.create_dialog.only_one_name_is_required')} (${this.$t('dashboard.menu.eventDetails.mandatory-optional')})`]
        },
        english() {
            return this.practice.english;
        },
        french() {
            return this.practice.french;
        },
        spanish() {
            return this.practice.spanish;
        }
    },
    watch: {
        english(val) {
            this.practice.english = val.trim();
        },
        french(val) {
            this.practice.french = val.trim();
        },
        spanish(val) {
            this.practice.spanish = val.trim();
        }
    },
    methods: {
        focusValidate()
        {
            this.$refs.form.validate();
        },
        validate()
        {
            const isValid = this.$refs.form.validate();
            if (isValid)
            {
                this.loading = true;
                this.$emit('createPractice', this.practice);
            }
            
        },
        reset()
        {
            this.practice.english = '';
            this.practice.french = '';
            this.practice.spanish = '';
            this.$refs.form.resetValidation();
        },
        close()
        {
            this.dialog = false;
            this.loading = false;
            this.reset();
        },
        openDeleteConfirmationDialog()
        {
            this.confirmationDialog = true;
        },
        deletePrice()
        {
            this.confirmationDialog = false;
            this.$emit('deletePractice');
        }
    },
}
</script>